import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

let initialRole = 'gd';
if(localStorage.getItem('userRole')) initialRole = localStorage.getItem('userRole')

export default new AclCreate({
  initial: initialRole,
  notfound: '/pages/not-authorized',
  router,
  acceptLocalRules: true,
  globalRules: {
    globalDistrict: new AclRule('gd').generate(),
    localDistrict: new AclRule('ld').generate(),
    dealer: new AclRule('d').generate(),
    user: new AclRule('u').generate(),

    globalOrLocal: new AclRule('gd').or('ld').generate(),
    allWithoutUser: new AclRule('gd').or('ld').or('d').generate(),
    dealerOrUser: new AclRule('d').or('u').generate(),
    public: new AclRule('gd').or('ld').or('d').or('u').generate(),
  }
})
